module.exports = __webpack_public_path__ + "static/media/imgbk.5b650ba9.JPG";